import { render, staticRenderFns } from "./rightItem02.vue?vue&type=template&id=8b377b50&scoped=true&"
import script from "./rightItem02.vue?vue&type=script&lang=js&"
export * from "./rightItem02.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b377b50",
  null
  
)

export default component.exports